import{useTheme as r}from"@emotion/react";import{useCallback as t}from"react";import o from"./cxs.js";import{parseCssStyles as e}from"./parse-styles.js";function m(){var m=r();return t((function(r){return o(e(r,null,m))}),[m])}export{m as default};
//# sourceMappingURL=use-css.js.map
